<template>
  <div class="vue-component">
    <EcPassELearning />
  </div>
</template>

<script>
import EcPassELearning from './components/EcPassELearning.vue'
import baseAppFactory from '../common/baseAppFactory'

export default baseAppFactory({ EcPassELearning })
</script>
